/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Grid,
  Typography,
  Divider,
  TextField,
  Box,
  Paper,
  FormControl,
  FormHelperText
} from "@mui/material";
import { STYLES } from "config";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";
import { FirebaseContext } from "common";

function ContentStep(props, ref) {
  const { api } = useContext(FirebaseContext);
  const { PPTokenGenerator } = api;
  const dispatch = useDispatch();
  const cities = useSelector((state) => state.citiesdata.city);
  const suburbs = useSelector((state) => state.citiesdata.suburb);
  const areaData = useSelector((state) => state.areaData);
  const auth = useSelector((state) => state.auth);
  const { data, setvalue } = props;

  const [areaList, setAreaList] = useState([]);

  useEffect(() => {
    dispatch(PPTokenGenerator());
    let arr2 = [];

    if (areaData && areaData.areas) {
      for (let index = 0; index < areaData.areas.length; index++) {
        const element = areaData.areas[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (
          element.selectedBranchName === auth?.info?.profile?.adminHomeOffice
        ) {
          console.log(`match`);
          arr2.push({
            value: element.areaId,
            label: element.areaName
          });
        }
      }
      setAreaList(arr2.sort((a, b) => a.label.localeCompare(b.label)));
      console.log("Area List:", arr2.length > 0 ? arr2 : "No areas found"); // Log area list to verify population
    }
  }, [areaData]);

  const [state, setstate] = useState(data);
  const [errors, setErrors] = useState({
    marketingHeading: false,
    description: false,
    area: false
  });

  const [citieOptions, setCityOptions] = useState([]);
  const [suburbOption, setSuburbOption] = useState([]);

  useEffect(() => {
    setstate(data);
  }, [data]);

  useEffect(() => {
    if (cities?.cities?.length > 0) {
      const formattedCities = cities.cities.map((city) => ({
        value: city.id,
        label: city.name
      }));
      setCityOptions(formattedCities);
      console.log(formattedCities);
    }
  }, [cities]);

  useEffect(() => {
    if (suburbs?.suburbs?.length > 0) {
      const formattedSuburbs = suburbs.suburbs.map((sub) => ({
        value: sub.id,
        label: sub.name
      }));
      setSuburbOption(formattedSuburbs);
    }
  }, [suburbs]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...state, [name]: value };

    // Validate required fields
    if (name === "marketingHeading" || name === "description") {
      setErrors((prev) => ({
        ...prev,
        [name]: !value.trim()
      }));
    }

    setstate(updatedState);
    setvalue(updatedState);
  };

  console.log("state?.selectedArea?.areaId", state?.selectedArea?.areaId);
  console.log("data?.address", data?.address);

  const handleSelectChange = (name, value) => {
    const updatedState = { ...state, [name]: value };

    // Validate required selects
    if (name === "provinceId" || name === "cityId" || name === "suburbId") {
      setErrors((prev) => ({
        ...prev,
        [name]: !value
      }));
    }

    setstate(updatedState);
    setvalue(updatedState);
  };

  const validateForm = () => {
    const newErrors = {
      marketingHeading: !state.marketingHeading?.trim(),
      description: !state.description?.trim(),
      area: !state.selectedArea
    };

    setErrors(newErrors);

    return !Object.values(newErrors).some((error) => error);
  };

  // Expose validation to parent component
  React.useImperativeHandle(ref, () => ({
    isValidated: validateForm,
    state
  }));

  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Content
      </Typography>
      <Divider sx={{ my: 2 }} />

      <Box sx={{ mb: 3 }}>
        <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
          <Typography
            variant="body1"
            paragraph
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <span>
              <strong>Follow the steps to publish your listing:</strong> Click
              Next or Complete Step at the bottom of the screen to move on. Once
              you start the publishing process, you must complete all steps,
              work cannot be saved.
            </span>
          </Typography>
        </Paper>
      </Box>

      <Divider sx={{ my: 2 }} />
      <Grid item size={12} sm={12} md={12} lg={12}>
        <Grid container spacing={3}>
          {/* Title Field */}
          <Grid item size={2}>
            <Typography variant="subtitle1" gutterBottom>
              Marketing Heading: <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              required
              fullWidth
              size="small"
              name="marketingHeading"
              value={state?.marketingHeading || ""}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
              error={errors.marketingHeading}
              helperText={errors.marketingHeading ? "Title is required" : ""}
              required
            />
          </Grid>

          {/* Article Description */}
          <Grid item size={2}>
            <Typography variant="subtitle1" gutterBottom>
              Marketing Description: <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              multiline
              rows={6}
              name="description"
              value={state?.description || ""}
              onChange={handleChange}
              error={errors.description}
              helperText={errors.description ? "Description is required" : ""}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          {/* Address Section */}
          <Grid item size={12}>
            <Divider sx={{ my: 2 }} />
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom>
              ADDRESS: {data?.address?.description}
            </Typography>
          </Grid>

          <Grid item size={2}>
            <Typography variant="subtitle1" gutterBottom>
              Area *:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <FormControl fullWidth error={errors.catId}>
              {areaData && areaData.areas.length > 0 ? (
                <CustomDropDownPicker
                  options={areaList}
                  isMulti={false}
                  value={data?.selectedArea?.areaId}
                  onChange={(selectedArea) => {
                    let fullArea = areaData.areas.find(
                      (x) => x.areaId === selectedArea
                    );

                    console.log("fullArea", fullArea);

                    setvalue({
                      ...data,
                      selectedArea: fullArea,
                      suburbId: fullArea.p24.suburbId,
                      cityId: fullArea.p24.cityId,
                      provinceId: fullArea.p24.provinceId,
                      address: {
                        ...state.address,
                        coords: {
                          lat: fullArea.p24.geoPoint.latitude,
                          lng: fullArea.p24.geoPoint.longitude
                        }
                      }
                    });
                  }}
                />
              ) : (
                <FormText color="grey">No areas available</FormText> // Fallback if no areas
              )}
              {errors.area && (
                <FormHelperText error>Area is required</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default React.forwardRef(ContentStep);
